import React from 'react';
import Svg from '../Svg';

const IconItalic01 = ({ ...props }) => (
  <Svg {...props} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.977 2.99978H10C9.44772 2.99978 9 3.4475 9 3.99978C9 4.55207 9.44772 4.99978 10 4.99978H13.557L8.307 18.9998H5C4.44772 18.9998 4 19.4475 4 19.9998C4 20.5521 4.44772 20.9998 5 20.9998H8.97666C8.99216 21.0001 9.00762 21.0001 9.02304 20.9998H14C14.5523 20.9998 15 20.5521 15 19.9998C15 19.4475 14.5523 18.9998 14 18.9998H10.443L15.693 4.99978H19C19.5523 4.99978 20 4.55207 20 3.99978C20 3.4475 19.5523 2.99978 19 2.99978H15.0233C15.0078 2.99942 14.9924 2.99942 14.977 2.99978Z"
    />
  </Svg>
);

export default IconItalic01;
